import { CallRestrictionsResponse } from '../typings/meta-call-restrictions';
import { createRequestAtom } from '../utils/request-atom';

export const callRestrictionResponseAtom = createRequestAtom<CallRestrictionsResponse>();
